<script>
    import { onMount } from 'svelte';
    import Button from './Button.svelte';
    import Card from './Card.svelte';
    import MailBegar from './MailBegar.svelte';
    import Prose from './Prose.svelte';
    import SocialShare from './SocialShare.svelte';
    import { site_origin } from './stores/globals';
    import { img_cdn } from './utils/image';

    export let puzzle;
    let className = '';
    export { className as class };

    let is_answer = false;

    let seen_answers = 0;
    let begged = false;

    onMount(() => {
        seen_answers = parseInt(localStorage.getItem('seen_answers') || '0');
    });

    const rotate = () => {
        if (!is_answer) {
            seen_answers++;
            localStorage.setItem('seen_answers', seen_answers.toString());

            if (seen_answers >= 3 && !begged) {
                show_mail_begar();
                begged = true;
            }
        }

        is_answer = !is_answer;
    };

    let show_mail_begar = () => {};

    // const handle_mail_begar_success = () => {
    //     is_answer = true;
    // };
</script>

<div class={className}>
    <div
        class="puzzle {is_answer ? 'is_answer' : ''} w-fit mx-auto"
        style:--puzzle-card-slug="puzzle-card-{puzzle.slug}"
        style:--card-bg={puzzle.color}
    >
        <button
            class="puzzle-card shrink-0 grow-0 {!is_answer
                ? 'puzzle-card-question'
                : 'puzzle-card-answer'}"
            on:click={rotate}
        >
            <img
                src={img_cdn(puzzle.images[0], { w: 420, h: 525 })}
                alt={puzzle.head_description}
                class="question block rounded-lg bg-(--card-bg)"
                loading="eager"
            />
            <img
                src={img_cdn(puzzle.images[1], { w: 420, h: 525 })}
                alt="Puzzle answer"
                class="answer block max-md:rounded-t-lg md:rounded-l-lg"
                loading="lazy"
            />
        </button>

        <div class="answer-text">
            <Card
                class="w-full h-full max-md:rounded-t-none md:rounded-l-none flex flex-col"
            >
                <Prose
                    sm
                    class="flex-1 md:overflow-y-scroll h-full overflow-gradient-y"
                >
                    <div class="py-4 pr-2">
                        {@html puzzle.body}
                    </div>
                </Prose>

                <SocialShare
                    text={puzzle.head_description}
                    url="{site_origin}/puzzles/{puzzle.slug}?utm_source=share&utm_medium=web&utm_campaign=puzzle"
                    img="{site_origin}{puzzle.images[2]}"
                    class="flex-0 border-t border-white/20 pt-4 w-full"
                    ><b>Share:</b></SocialShare
                >
            </Card>
        </div>
    </div>
    <Button outline class="mx-auto block w-fit mt-4" on:click={rotate}
        >{is_answer ? 'Hide Answer' : 'Show Answer'}</Button
    >
</div>

<MailBegar
    title="Enjoy puzzles?"
    lead="Join my newsletter for more puzzles and other critical thinking content."
    show_on_mount={false}
    bind:show={show_mail_begar}
    collapsible
    cta_text="Subscribe"
/>

<style>
    .puzzle {
        --w: 100%;
        width: var(--w);
        perspective: 4000px;
        view-transition-name: var(--puzzle-card-slug);
    }

    .puzzle-card,
    .answer-text {
        width: var(--w);
        display: block;
    }

    .puzzle-card {
        position: relative;
        width: 100%;
        height: 100%;
        aspect-ratio: 1080 / 1350;
        transform-style: preserve-3d;
        transform-origin: center;
        transition: transform 0.8s, scale 0.3s ease-in-out ;
        cursor: pointer;
    }

    .is_answer .puzzle-card {
        transform: translateZ(0px) rotateY(-180deg) !important;
    }

    .question,
    .answer {
        display: block;
        width: 100%;
        height: auto;
        aspect-ratio: 1080 / 1350;
        position: absolute;
        top: 0;
        left: 0;
        -webkit-backface-visibility: hidden; /* Safari */
        backface-visibility: hidden;
        z-index: 10;
    }

    .answer {
        /* opacity: 0; */
        transform: rotateY(180deg);
    }

    .answer-text {
        opacity: 0;
        display: none;
    }

    .is_answer .answer-text {
        opacity: 1;
        display: block;
    }

    /* Unfold like a book */
    @media (min-width: 640px) {
        .puzzle {
            --w: 320px;
            position: relative;
            transition: transform 0.8s;
            width: var(--w);
            aspect-ratio: 1080 / 1350;
            perspective: 4000px;
            /* border:4px solid #fff; */
            border-radius: var(--radius-lg);
            view-transition-name: var(--puzzle-card-slug);
        }

        .puzzle.is_answer {
            transform: translateX(50%);
        }

        .puzzle-card,
        .answer-text {
            width: var(--w);
            aspect-ratio: 1080 / 1350;
            display: block;
        }

        .puzzle-card {
            position: relative;
            width: 100%;
            height: 100%;
            transform-style: preserve-3d;
            transform-origin: left;
            transition: transform 0.8s;
        }

        .is_answer .puzzle-card {
            transform: translateZ(0px) rotateY(-180deg) !important;
        }

        .question,
        .answer {
            display: block;
            width: 100%;
            height: auto;
            aspect-ratio: 1080 / 1350;
            position: absolute;
            top: 0;
            left: 0;
            -webkit-backface-visibility: hidden; /* Safari */
            backface-visibility: hidden;
            z-index: 10;
        }

        .answer {
            /* opacity: 0; */
            transform: rotateY(180deg);
        }

        .answer-text {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            height: 100%;
            /* opacity: 0; */
            /* transform: translateX(-100%); */
            transform-origin: left;
            backface-visibility: hidden;
            transform-style: preserve-3d;
            transition: opacity 0.8s;
            z-index: -1;
            visibility: collapse;
        }

        .is_answer .answer-text {
            opacity: 1;
            transition: transform 0.8s;
            visibility: visible;
        }
    }

    @media (min-width: 1024px) {
        .puzzle {
            --w: 420px;
        }
    }

    :global(html)::view-transition-old(*),
    :global(html)::view-transition-new(*) {
        animation-duration: 0.6s;
        animation-timing-function: ease-in-out;
    }

    :global(html)::view-transition-old(root),
    :global(html)::view-transition-new(root) {
        animation: none;
    }
</style>
